import React from "react";
import { useNavigate } from "react-router-dom";
import "./SearchBox.css";

function SearchBox({
  searchResult,
  setSearchResult,
  setDropdownVisible,
  setSearchText,
}) {
  const navigate = useNavigate();

  const handleClick = (url) => {
    navigate(url);
    setSearchResult([]);
    setDropdownVisible(false);
    setSearchText("");
  };
  return (
    <ul className="search-items">
      {searchResult?.map((item) => (
        <li
          key={item.objectID}
          className="search-item"
          onClick={() => handleClick(item.pageUrl)}
        >
          {item?.name ? (
            <span className="onclick-text">
              {item?.name} <i class="fa-solid fa-envelope"></i>
            </span>
          ) : null}
          <div className="contact">
            {item?.address !== ",   " ? <span>{item?.address}</span> : null}
            {item.contact?.number && item.objectType !== "property" ? (
              <span>
                {item.contact?.type ? `${item.contact.type}:` : null}{" "}
                {item.contact?.number}
              </span>
            ) : null}
          </div>
          <span className={`object-type ${item.objectType + "Tag"}`}>{item?.objectType}</span>
        </li>
      ))}
    </ul>
  );
}

export default SearchBox;
